import React from "react";
import { Card, CardBody, Container, Row, Col, Button } from "reactstrap";
import { getStats } from "../../components/helpers/StatsHelpers";
import { RiPriceTag3Line } from "react-icons/ri";
import { SeoHelper } from "../../components/helpers/SeoHelper";
import InstructionsWizard from "./InstructionsWizard";

class CreateACuratedSongFlowFromAThemeHelp extends React.Component {
  state = { songBookCount: null };

  constructor(props) {
    super(props);
    getStats.call(this);
  }

  stepsData = [
    {
      title: "Create a curated song-flow from a Theme",
      description:
        "At the end of this guide you will have:<br/><br/>" +
        "<img src=\"/help-images/blue-arrow.png\" style=\"width: 40px; height: auto;\">&nbsp;" +
        "created a song-flow using a worship theme as your starting point",
    },
    {
      title: "From the home page",
      description:
        "The <a href='/themes/choose-themes'>Build from a Theme</a> feature is available from the <a href='/'>home page</a>. " +
        "Find the <b>Build from a Theme</b> option and click it to begin selecting your theme.",
    },
    {
      title: "Choose a theme",
      description:
        "On the theme selection page, use the dropdown to search for and select a worship theme. Click <b>ADD</b> to add it to your selection." +
        "<br/><br/>You can add multiple themes if you are signed in. If you are not signed in, you will be limited to a single theme at a time.",
    },
    {
      title: "Continue to songs",
      description:
        "Once you have selected your theme or themes, click <b>CONTINUE</b> at the bottom of the page. " +
        "You will be taken to a list of songs that match your chosen theme.",
    },
    {
      title: "Choose your songs",
      description:
        "You are now presented with a list of songs related to your selected theme. Each song displays its title, author, song book, and where available, key, time signature, tempo, and CCLI number." +
        "<br/><br/>Click the selector toggle next to any song to add it to your song-flow. Click it again to remove it. " +
        "When you have made your selection, click <b>CURATE SONG-FLOW</b> at the bottom of the page.",
    },
    {
      title: "Your curated song-flow",
      description:
        "Your song-flow is now ready. You can review the songs in order, drag them to rearrange the sequence, and save it if you have a paid account." +
        "<br/><br/>Free accounts can share a song-flow up to 3 times. Paid accounts can save and share without limit.",
    },
    {
      title: "What's next",
      description:
        "You have built a song-flow from a theme. Here are some things you can do next:" +
        "<br/><br/><img src=\"/help-images/star.png\" style=\"width: 40px; height: auto;\"> <a href='/help/create-a-curated-song-flow-from-scripture'>Create a song-flow from Scripture</a>" +
        "<br/><br/><img src=\"/help-images/star.png\" style=\"width: 40px; height: auto;\"> <a href='/help/adding-songs-from-multiple-sources'>Add songs from multiple sources</a>" +
        "<br/><br/><img src=\"/help-images/star.png\" style=\"width: 40px; height: auto;\"> <a href='/help/saving-and-managing-your-song-flows'>Save and manage your song-flows</a>",
      image: "/help-images/well-done.png",
      enlargeable: false,
    },
  ];

  render() {
    return (
      <>
        <SeoHelper
          uri="/help/create-a-curated-song-flow-from-a-theme"
          title="Create a curated song-flow from a Theme | Help | The Worship Bible"
          description="Details how to generate a song-flow by selecting one or more worship themes."
        />
        <div className="position-relative">
          <section className="section section-lg section-shaped pb-250">
            <div className="shape shape-style-1 shape-default">
              <span/><span/><span/><span/><span/><span/><span/><span/><span/>
            </div>
            <Container className="py-lg-md d-flex">
              <div className="col px-0">
                <Row>
                  <Col lg="8">
                    <h1 className="display-3 text-white">
                      Building your song-flows{" "}<span>help</span>
                    </h1>
                  </Col>
                </Row>
              </div>
            </Container>
            <div className="separator separator-bottom separator-skew">
              <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" version="1.1" viewBox="0 0 2560 100" x="0" y="0">
                <polygon className="fill-white" points="2560 0 2560 100 0 100"/>
              </svg>
            </div>
          </section>
        </div>
        <section className="section section-lg pt-lg-0 mt--200">
          <Container>
            <Row className="justify-content-center">
              <Col lg="12">
                <Row className="row-grid">
                  <Col lg="12">
                    <Card className="card-lift--hover shadow border-0">
                      <CardBody className="py-5">
                        <Row className="mt-3">
                          <Col>
                            <div className="d-flex align-items-center mb-3">
                              <RiPriceTag3Line color="#5e72e4" size="24" className="mr-2"/>
                              <h2 style={{fontSize: "1rem"}} className="text-primary mb-0">Create a curated song-flow from a Theme</h2>
                            </div>
                          </Col>
                          <Col md="3" xs="12">
                            <Button block type="button" className="mb-2" color="white" href="/help">
                              <span className="btn-inner--text">Back to help</span>
                            </Button>
                          </Col>
                        </Row>
                        <InstructionsWizard stepsData={this.stepsData}/>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </section>
      </>
    );
  }
}

export default CreateACuratedSongFlowFromAThemeHelp;
